module.exports = __webpack_public_path__ + "img/2025-01-09a_1.d0aff21b.jpg";